export enum ValueType {
  EURO = '€',
  NULL = '',
  PERCENTUALE = '%',
  GIORNI = 'gg',
}

export enum StructureTypes {
  BUSINESS = 'business',
  DELIVERY = 'delivery',
}

export enum TrackPagesGA4Enum {
  PROJECT_LIST = 'project-list',
  PROJECT_DETAIL = 'project-detail',
  CDG = 'cdg-management-tools',
  CL = 'cl-management-tools',
  PL = 'pl-management-tools',
  DASHBOARD_PROJECTS = 'dashboard-projects',
  DASHBOARD_RESOURCES = 'dashboard-resources-planning',
  DASHBOARD_UNDERBOOKING = 'dashboard-underbooking',
  DASHBOARD_OVERBOOKING = 'dashboard-overbooking',
  PASSIVE_CYCLE = 'passive-cycle',
  ACTIVE_CYCLE = 'active-cycle',
  CL_PROJECTS = 'cl-projects',
}

export enum DelegateTypesEnum {
  PROJECT = 'project',
  HCC = 'hcc',
}

export enum LocationFilterEnum {
  PROJECT_LIST = 'project-list',
  CL_PROJECTS = 'cl-projects',
  MT_PL = 'pl',
  MT_CL = 'cl',
  MT_CDG = 'cdg',
  ACTIVE_CYCLE = 'active-cycle',
  ACTIVE_CYCLE_INVOICES = 'active-cycle-invoices',
  PASSIVE_CYCLE = 'passive-cycle',
  PASSIVE_CYCLE_INVOICES = 'passive-cycle-invoices',
  CL_ORDERS = 'cl-orders',
  DASHBOARD_PROJECTS = 'dashboard-projects',
  DASHBOARD_RESOURCES = 'dashboard-resources-planning',
  DASHBOARD_SAL_PLANNING = 'dashboard-sal-planning',
  BILLS_ACTIVE_CYCLE = 'bills-active-cycle',
  BILLS_PASSIVE_CYCLE = 'bills-passive-cycle',
  AUDIT_ACTIONS = 'audit-actions',
}
